module.exports = __webpack_public_path__ + "media/assets/images/category/OfficeFun@2x-3f8ff9497e2f748e451d9c79fdf4e30e.png";